const { default: filterMilestoneByPlanningSummary } = require("@/utils/filters/filterMilestonesByPlanningSummary");

const getPlanningSummary = (milestone) => {
    const summaries = [
      'Initiative on hold',
      'Initiative cancelled',
      'Late (more than 4 weeks)',
      'Late (1 to 4 weeks)',
      'Late (less than 1 week)',
      'Late to start',
      'Not planned',
      'Not started',
      'Due soon',
      'Due soon for 30 days',
      'On plan',
      'Completed',
      'Cancelled',
      '<not set>',
    ];
  
    for (const summary of summaries) {
      if (filterMilestoneByPlanningSummary(milestone, initiative, [summary])) {
        return summary;
      }
    }
    return '<not set>'; // fallback
  };
export default getPlanningSummary;